import FormComponent from './Form';
import FormItem from './FormItem';
import { useForm } from './useForm';
import type { FormInstance, FormProps, FormItemProps, Rule, NamePath } from './types';
import type { ForwardRefExoticComponent, RefAttributes } from 'react';

type FormComponentType = ForwardRefExoticComponent<FormProps & RefAttributes<FormInstance>> & {
  Item: typeof FormItem;
  useForm: typeof useForm;
};

const Form = FormComponent as FormComponentType;

Form.Item = FormItem;
Form.useForm = useForm;

export default Form;
export { FormItem, useForm };
export type { FormInstance, FormProps, FormItemProps, Rule, NamePath };

